export default __webpack_public_path__ + "static/media/Ellipse 151.0ca53b9d.svg";